// src/store/auth.ts
import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { User, AuthState } from '../types/auth';

// Interface de l'état étendu pour inclure l'état d'hydratation
interface HydratedAuthState extends AuthState {
  _hasHydrated: boolean; // Ajoute une propriété pour suivre l'hydratation
  setHasHydrated: (hydrated: boolean) => void; // Ajoute une fonction pour mettre à jour cet état
}

export const useAuthStore = create<HydratedAuthState>()( // Utilise la nouvelle interface
  persist(
    (set) => ({
      token: null,
      user: null,
      _hasHydrated: false, // Initialisé à false

      login: (token: string, user: User) => {
        set({ token, user });
        console.log('Zustand Auth Store: User logged in, state updated.');
        console.log('Current Auth State (after login):', { token, user });
      },

      logout: () => {
        set({ token: null, user: null });
        console.log('Zustand Auth Store: User logged out, state cleared.');
      },

      setHasHydrated: (hydrated: boolean) => { // Nouvelle fonction pour mettre à jour l'état d'hydratation
        set({ _hasHydrated: hydrated });
        console.log('Zustand Auth Store: Hydration state set to', hydrated);
      },
    }),
    {
      name: 'auth-storage',
      storage: createJSONStorage(() => localStorage),
      // Callback pour l'hydratation
      onRehydrateStorage: () => (state) => {
        if (state) {
          state.setHasHydrated(true); // Appelle setHasHydrated une fois l'état hydraté
        }
      },
    }
  )
);